import React from 'react'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import UserAccessTableButtons from 'user_access/UserAccessTableButtons'
import UserRole from 'utils/UserRole'
import UserDepartment from 'utils/UserDepartment'

class UserAccessTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <div className="user-access-table" style={{paddingTop: "75px"}}>
          <div className="float-left">
            <h5>{this.props.tableName}</h5>
          </div>
          <div className="collapser float-right" data-toggle="collapse">
            <p style={{ fontSize: "16px" }} className="text-primary mb-0">Collapse Section&nbsp;<i className={"fas" + (this.props.users.length > 0 ? " fa-sort-up" : " fa-sort-down")}></i></p>
          </div>
          <div className={"pt-3 collapse clear-both" + (this.props.users.length > 0 ? " show" : "")}>
            <div className="table-responsive">
              <Table striped className="mt-2 table-white">
                <thead>
                  <tr>
                    <th style={{width: '8%'}}>ID#</th>
                    <th style={{width: '20%', minWidth: "200px"}}>Name</th>
                    <th style={{width: '25%', minWidth: "300px"}}>Email</th>
                    <th style={{width: '10%'}}>Role</th>
                    <th style={{width: '10%'}}>Department</th>
                    <th style={{width: '27%'}}></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.props.users.map((user) => {
                      return (
                        <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td><UserRole role={user.role} /></td>
                          <td><UserDepartment department={user.department} /></td>
                          <td className="text-right">
                            <div style={{display: "flex", flexWrap: "nowrap", whiteSpace: "nowrap"}}>
                              {
                                (this.props.permissions.includes(user.role) || user.role == "unaffiliated") && (
                                  <UserAccessTableButtons org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} user={user} deleteUser={this.props.deleteUser} removeUser={this.props.removeUser} />
                                )
                              }
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
          <div className="clear-both"></div>
        </div>
      </>
    );
  }
}

export default UserAccessTable;
